import SwiftOfflineIndicator from 'src/components/SwiftOfflineIndicator';
import { SwiftToggleSwitch } from 'src/components/TradeForm/SwiftToggleSwitch';
import useIsSwiftEnabledForUser from 'src/hooks/signedMsgOrders/useIsSwiftEnabledForUser';
import { useSwiftServerHealthCheck } from 'src/hooks/swift/useSwiftServerHealthcheck';

interface Props {
	toggleState: boolean | undefined;
	onToggleStateChange: (val?: boolean) => void;
}

export default function SwiftSettings({
	toggleState,
	onToggleStateChange,
}: Props) {
	const isSwiftEnabledForUser = useIsSwiftEnabledForUser();
	const isSwiftServerHealthy = useSwiftServerHealthCheck();

	const status = (() => {
		if (
			isSwiftEnabledForUser === undefined ||
			isSwiftServerHealthy === undefined
		) {
			return 'loading';
		}

		if (!isSwiftServerHealthy) {
			return 'offline';
		}

		return isSwiftEnabledForUser ? 'enabled' : 'disabled';
	})();

	const isToggleSwitchDisabled = status === 'loading' || status === 'offline';

	// If the toggle hasn't been interacted with yet, we defer to the user's enabled status.
	const toggleValue = toggleState ?? !!isSwiftEnabledForUser;

	return (
		<div className="flex items-center justify-between gap-x-md">
			<div className="flex min-w-0 flex-1 flex-col gap-y-sm">
				<h3 className="flex items-center gap-x-xs typo-label-sm">
					Gasless Trading {status !== 'loading' && <SwiftOfflineIndicator />}
				</h3>
				<span className="typo-body-xs text-text-secondary">
					Enable fastest order execution with 0 gas fees
				</span>
			</div>
			<SwiftToggleSwitch
				value={toggleValue}
				onChange={onToggleStateChange}
				disabled={isToggleSwitchDisabled}
			/>
		</div>
	);
}
